import React from "react";
import { useLocation } from "react-router-dom";

const CommonComingSoon = () => {
  const location = useLocation();

  // route se dynamic title generate
  const formatTitle = (path) => {
    return path
      .split("/")
      .filter(Boolean)
      .map((word) =>
        word
          .replace(/-/g, " ")
          .replace(/_/g, " ")
          .replace(/\b\w/g, (c) => c.toUpperCase())
      )
      .join(" ");
  };

  const pageName = formatTitle(location.pathname) || "Page";

  return (
    <div className="min-h-screen flex items-center justify-center p-6 montserrat-font-1">
      <div className="max-w-lg w-full bg-white rounded-2xl shadow-sm border montserrat-font-1 border-gray-200 p-8 text-center">

        {/* Icon */}
        <div className="mx-auto mb-6 flex montserrat-font-1 items-center justify-center w-16 h-16 rounded-full bg-blue-50">
          <svg
            className="w-8 h-8 text-blue-600"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 6v6l4 2"
            />
          </svg>
        </div>

        {/* Title */}
        <h1 className="text-2xl font-semibold text-gray-800 mb-2">
          {pageName} — Coming Soon
        </h1>

        {/* Description */}
        <p className="text-gray-600 text-sm leading-relaxed mb-6 montserrat-font-2">
          This module is currently under development.
          <br />
          <span className="block mt-2 font-medium text-gray-700 montserrat-font-2">
            We’ll make it live soon 🚀
          </span>
        </p>

        {/* Divider */}
        <div className="border-t border-gray-200 my-6"></div>

        {/* Features */}
        <div className="text-left space-y-3 text-sm text-gray-700 montserrat-font-1">
          <div className="flex gap-2">
            <span className="text-blue-600">✔</span>
            <span>Dynamic route-based page rendering</span>
          </div>
          <div className="flex gap-2">
            <span className="text-blue-600">✔</span>
            <span>Future feature placeholder</span>
          </div>
          <div className="flex gap-2">
            <span className="text-blue-600">✔</span>
            <span>Easy integration with new modules</span>
          </div>
        </div>

        {/* Badge */}
        <div className="mt-6 flex justify-center">
          <span className="bg-yellow-100 text-yellow-700 text-xs font-medium px-4 py-1.5 rounded-full">
            🚧 Work in Progress
          </span>
        </div>

      </div>
    </div>
  );
};

export default CommonComingSoon;